import { render, staticRenderFns } from "./PaymentTab.vue?vue&type=template&id=2c1db6fc&scoped=true&"
import script from "./PaymentTab.vue?vue&type=script&lang=js&"
export * from "./PaymentTab.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTab.vue?vue&type=style&index=0&id=2c1db6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1db6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1db6fc')) {
      api.createRecord('2c1db6fc', component.options)
    } else {
      api.reload('2c1db6fc', component.options)
    }
    module.hot.accept("./PaymentTab.vue?vue&type=template&id=2c1db6fc&scoped=true&", function () {
      api.rerender('2c1db6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/tabs/PaymentTab.vue"
export default component.exports